import React from 'react';

const Logo = ({ width = 160, height = 45, className = '' }) => {
  return (
    <img
      src="/ValoriaLogo_Backup.png"
      alt="Valoria Logo"
      className={className}
      style={{ width, height }}
    />
  );
};

export default Logo;
